import { useEffect, useMemo, useState } from "react";
import { Button, Label, Progress } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import chestImage from "../../images/Task/task-award_achieve.webp";

import InputCustom from "../../components/InputComponents/InputCustom";
import CommonTab from "../../components/TabComponent/CommonTab";
import CommonBorder from "../../components/BorderComponent/CommonBorder";
import { commonOpacity } from "../../animateConstant";
// import {
//   actionUseGift,
//   getMemberInfo,
//   playerGiftDetail,
//   useGift,
// } from "../../api/api";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import { formatNumber } from "../../utils/formatNumber";
import { CURRENCY_SYMBOL } from "../../constant";
import dayjs from "dayjs";
import { giftStatus } from "./utils/RewardStatus";
import { loading, loadingDestroy, notice } from "../../redux/action/action";
import CommonProgress from "../../components/CommonProgress/CommonProgress";
import { storeMemberInfo } from "../../redux/action/member/memberAction";
import Empty from "../../components/Empty/Empty";

const TAB = [{ label: "Prizes", value: "Prizes" }];

const timeToNumber = (date) => dayjs(date).unix();

const Rewards = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`reward.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);

  const [tab, setTab] = useState(TAB[0].value);
  const [data, setData] = useState({});
  const [dataFocus, setDataFocus] = useState({});
  const [giftList, setGiftList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [demo, setDemo] = useState(false);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleFocus = (e) => {
    setDataFocus({ [e.target.name]: true });
  };

  useEffect(() => {
    setIsLoading(true);
    // playerGiftDetail()
    //   .then((data) => {
    //     if (data.code === "Ok") {
    //       setGiftList(data.giftList);
    //     } else {
    //     }
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });
  }, [trigger]);

  const giftUsing = useMemo(() => {
    return giftList.some((item) => item.isuse === 1 && item.isfinish === 0);
  }, [giftList]);

  const handleUseGift = (hash) => {
    dispatch(loading());
    setButtonLoading(true);
    // actionUseGift({ hash: hash })
    //   .then((data) => {
    //     if (data.code === "Ok") {
    //       setTrigger(!trigger);
    //       dispatch(notice(data.msg, "success"));

    //       getMemberInfo().then((data) => {
    //         if (data.code === "Ok") {
    //           dispatch(storeMemberInfo(data));
    //         }
    //       });
    //     } else {
    //     }
    //   })
    //   .finally(() => {
    //     setButtonLoading(false);
    //     dispatch(loadingDestroy());
    //   });
  };

  return (
    <motion.main
      initial={commonOpacity.initial}
      animate={commonOpacity.animate}
      exit={commonOpacity.exit}
      transition={commonOpacity.transition}
      className="bg-second-color py-[15px]"
    >
      <section className="mb-[15px] px-common-padding-x">
        <p className="text-2xl font-bold text-main-color text-center mb-[8px]">
          {i18n("title")}
        </p>
        <p className="text-dark-gray-text text-sm font-semibold text-center">
          {i18n("hint1")}
        </p>
      </section>
      <section className="sm:flex gap-[30px]">
        <section className="w-full px-common-padding-x">
          <div className="bg-input-color px-common-padding-x py-[20px] rounded-xl">
            <p className="text-dark-gray-text font-bold text-xl">
              {i18n("reedom")}
            </p>
            <div className="flex gap-[8px] items-center">
              <InputCustom
                notMargin
                name="promoCode"
                placeholder="Enter your promo code"
                type="text"
                setDataProps={setData}
                dataProps={data}
                onChange={(e) => handleChange(e)}
                onFocus={(e) => handleFocus(e)}
                focusProps={dataFocus}
                className="!bg-gray-button-bg border focus:!border-main-input-border"
              />
              <Button
                disabled={!data.promoCode}
                size="small"
                content={i18n("submit")}
                className="!bg-main-color text-white !mb-[10px]"
              />
            </div>
          </div>
        </section>
        <section className="w-full mt-[24px]">
          <div className="flex items-center">
            {TAB.map((item, index) => {
              return (
                <CommonTab
                  key={index}
                  setTab={setTab}
                  tab={tab}
                  label={item.label}
                  value={item.value}
                />
              );
            })}
          </div>
          <CommonBorder notMargin />

          <section className="p-common-padding-x sm:grid sm:grid-cols-2 sm:gap-[10px]">
            <div className="min-h-[100px] w-full rounded-xl bg-input-color mb-[10px] text-light-white overflow-hidden">
              <div className="px-[20px] py-[13px] w-full flex items-center justify-between relative bg-[rgb(127,95,70)]">
                <p className="text-light-white text-lg font-semibold mb-0 w-[85%]">
                  {`Demo Gift`}
                </p>
                <img
                  src={chestImage}
                  className="w-[60px] absolute right-0 mb-[8px]"
                />
              </div>
              <div className="px-[20px] py-[10px]">
                <div className="text-sm text-light-text font-semibold mb-[10px]">
                  <p className="mb-[2px]">
                    {i18n("bonus")}: {CURRENCY_SYMBOL}
                    &nbsp;
                    {formatNumber(100)}
                  </p>
                  <p className="">
                    {i18n("wager")}: {CURRENCY_SYMBOL}
                    &nbsp;
                    {formatNumber(200)}
                  </p>
                </div>
                {demo && (
                  <div className="mb-[10px]">
                    <CommonProgress firstValue={200} secondValue={1000} />
                  </div>
                )}
                <Button
                  type="button"
                  size="tiny"
                  disabled={demo}
                  onClick={() => setDemo(true)}
                  className={`!bg-main-color !text-light-white !w-full !mb-[10px] custom-button ${
                    demo ? "custom-using-this" : "custom-button"
                  }`}
                >
                  {demo ? i18n("Gift using") : i18n("GET GIFT")}
                </Button>
                <div className="flex items-center justify-center text-sm text-light-text font-semibold">
                  <p className="mb-0">
                    {i18n("Expire in")}{" "}
                    <span className="text-main-color">{`2029-10-01`}</span>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <LoaderComponent commonLoading={isLoading}>
            <section className="p-common-padding-x sm:grid sm:grid-cols-2 sm:gap-[10px]">
              {giftList.length === 0 ? (
                <Empty />
              ) : (
                giftList
                  .filter((item) => {
                    const etdToNumber = timeToNumber(item.openetd);
                    const today = dayjs().unix();

                    const eventEnded = today > etdToNumber;
                    const isFinish = item.isfinish === 1;

                    return !isFinish && !eventEnded;
                  })
                  ?.map((item, index) => {
                    const giftName = item.goodsname;
                    const etd = item.openetd;
                    const bonusPoints = item.bonuspoint;
                    const wagerPoints = item.washpoint;

                    const thisGiftUsing =
                      item.isuse === 1 && item.isfinish === 0; //判斷正在使用中的禮包

                    return (
                      <div
                        key={index}
                        className="min-h-[100px] w-full rounded-xl bg-input-color mb-[10px] text-light-white overflow-hidden"
                      >
                        <div className="px-[20px] py-[13px] w-full flex items-center justify-between relative bg-[rgb(127,95,70)]">
                          <p className="text-light-white text-lg font-semibold mb-0 w-[85%]">
                            {giftName}
                          </p>
                          <img
                            src={chestImage}
                            className="w-[60px] absolute right-0 mb-[8px]"
                          />
                        </div>
                        <div className="px-[20px] py-[10px]">
                          <div className="text-sm text-light-text font-semibold mb-[10px]">
                            <p className="mb-[2px]">
                              {i18n("bonus")}: {CURRENCY_SYMBOL}
                              &nbsp;
                              {formatNumber(bonusPoints)}
                            </p>
                            <p className="">
                              {i18n("wager")}: {CURRENCY_SYMBOL}
                              &nbsp;
                              {formatNumber(wagerPoints)}
                            </p>
                          </div>
                          {thisGiftUsing && (
                            <div className="mb-[10px]">
                              <CommonProgress
                                firstValue={memberData?.total_bet}
                                secondValue={memberData?.washCheck}
                              />
                            </div>
                          )}
                          <Button
                            type="button"
                            size="tiny"
                            disabled={buttonLoading || giftUsing}
                            onClick={() => handleUseGift(item.hash)}
                            className={`!bg-main-color !text-light-white !w-full !mb-[10px] ${
                              thisGiftUsing
                                ? "custom-using-this"
                                : "custom-button"
                            }`}
                          >
                            {thisGiftUsing
                              ? i18n("Gift using")
                              : giftUsing
                              ? i18n("Other gift pack is use")
                              : i18n("GET GIFT")}
                          </Button>
                          <div className="flex items-center justify-center text-sm text-light-text font-semibold">
                            <p className="mb-0">
                              {i18n("Expire in")}{" "}
                              <span className="text-main-color">{etd}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
              )}
            </section>
          </LoaderComponent>
        </section>
      </section>
    </motion.main>
  );
};

export default Rewards;
